module.exports = __webpack_public_path__ + "img/bg-new-5.6e402125.png";